import { render } from "./HarvesterSupportBundle.vue?vue&type=template&id=4a47548f&scoped=true"
import script from "./HarvesterSupportBundle.vue?vue&type=script&lang=js"
export * from "./HarvesterSupportBundle.vue?vue&type=script&lang=js"

import "./HarvesterSupportBundle.vue?vue&type=style&index=0&id=4a47548f&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4a47548f"]])

export default __exports__